import React, { useEffect, useState, ReactNode } from 'react';
import { useLocation, Link } from 'react-router';
import { MenuEntry, selectMenuData } from '../../../ducks/app';
import { useSelector } from "react-redux";
import './style.scss';

interface BreadcrumbProps {
  name: string;
}


const Breadcrumb: React.FC<BreadcrumbProps> = ({ name }) => {
  const [breadcrumb, setBreadcrumb] = useState<ReactNode[]>([]);
  const url = useLocation().pathname;
  const menuData = useSelector(selectMenuData);

  useEffect(() => {
    getBreadcrumb(menuData);
  }, [url, menuData, name]);

  const getPath = (data: MenuEntry[], url: string, parents: MenuEntry[] = []): MenuEntry[] => {
    let items = data.reduce(
      (result: MenuEntry[], entry: MenuEntry) => {
        if (result.length) {
          return result;
        } else {
          if ("url" in entry && entry.url === url) {
            return [entry, ...parents];
          } else if ("children" in entry) {
            let nested = getPath(entry.children, url, parents);
            return nested.length ? nested : result;
          }
        }
        return result;
      },
      [] as MenuEntry[]
    );
    return items;
  }

  const getBreadcrumb = (items: MenuEntry[]) => {
    let [activeMenuEntry, ...path] = getPath(items, url);
    if (activeMenuEntry && path.length) {
      setBreadcrumb(path.reverse().map((item, index) => {
        if (index === path.length - 1) {
          return (
            <span key={item.key}>
              <span className="breadcrumbBar__arrow text-muted" />
              <span className="text-muted">{item.title}</span>
              <span className="breadcrumbBar__arrow text-muted" />
              <strong>
                <span className="breadcrumbBar__active">{activeMenuEntry.title}</span>
              </strong>
            </span>
          );
        } else {
          return (
            <span key={item.key}>
              <span className="breadcrumbBar__arrow text-muted" />
              <span className="text-muted">{item.title}</span>
            </span>
          );
        }
      }));
    } else {
      const linkName = activeMenuEntry ? activeMenuEntry.title : name;
      setBreadcrumb(
        [<span key="breadcrumb-active">
          <span className="breadcrumbBar__arrow text-muted" />
          <strong>
            <span className="breadcrumbBar__active">{linkName}</span>
          </strong>
        </span>]
      );
    }
  }

  return (
    <div className="breadcrumbBar">
      <div className="breadcrumbBar__path">
        <span key="breadcrumb-home">
          <Link to={`/searchAppeals`} className="text-muted">
            Home
          </Link>
        </span>
        {breadcrumb}
      </div>
    </div>
  );
}

export default Breadcrumb;